import { z } from "zod/v4";
import { apiFetch } from "@/lib/apiClient";
import type { AnalyticsEvent } from "./contract";
export const analyticsPreferenceSchema = z.strictObject({
  enabled: z.boolean(),
  consented: z.boolean(),
  version: z.uuid(),
});
export type AnalyticsPreference = z.infer<typeof analyticsPreferenceSchema>;
export async function getAnalyticsPreference(signal?: AbortSignal) {
  return analyticsPreferenceSchema.parse(
    await apiFetch("/users/me/analytics", { signal }),
  );
}
export async function saveAnalyticsPreference(
  version: string,
  consented: boolean,
) {
  return analyticsPreferenceSchema.parse(
    await apiFetch("/users/me/analytics", {
      method: "PATCH",
      body: JSON.stringify({ version, consented }),
    }),
  );
}
export async function relayAnalyticsEvent(
  event: AnalyticsEvent,
  signal: AbortSignal,
) {
  z.strictObject({ accepted: z.boolean() }).parse(
    await apiFetch("/users/me/analytics/events", {
      method: "POST",
      body: JSON.stringify(event),
      signal,
      referrerPolicy: "no-referrer",
      redirect: "error",
    }),
  );
}
export function analyticsPreferenceOptions(actorKey: string) {
  return {
    queryKey: ["analytics-preference", actorKey],
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      getAnalyticsPreference(signal),
    retry: false,
    staleTime: 30_000,
    gcTime: 0,
  };
}
